import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.dashboard.learning-opportunity-recommendations.headline',
        page: lazyLoad(async () => {
            const { LearningOpportunityRecommendationsPage } = await import('./LearningOpportunityRecommendationsPage');

            return { default: LearningOpportunityRecommendationsPage };
        }),
        path: '/learning-opportunity-recommendations/:ambitionId',
    },
];
